import { createContext, useState, useEffect, useCallback, useContext } from "react";
import { Flex } from "uikit-react";
import { useCookies } from "react-cookie";

import Pagination from "../../common/Pagination";
import RecordsPerPage from "../../common/RecordsPerPage";
import { AppContexts } from "../../../providers";

import usePath from "../Common/History";

const BookingSourceMapping = () => {
  const [page, setPage] = useState(0);
  const [cookies] = useCookies(["records-per-page"]);
  const { "records-per-page": recordsPerPage = 20 } = cookies;

  const {
    active,
    bookingSourceMapping,
    getBookingSourceMapping,
  } = useContext(AppContexts.ReportsContext);

  const path = usePath();
  const { total = 0, paginated = [] } = bookingSourceMapping || {};

  useEffect(() => {
    if (path !== active) setPage(0);
  }, [path, active]);

  useEffect(() => {
    if (active === "booking-source-mapping") {
      getBookingSourceMapping(page, recordsPerPage);
    }
  }, [active, page, recordsPerPage]);

  const handlePageChange = useCallback((pageIndex) => {
    setPage(pageIndex);
  }, []);

  return (
    <li className="reports-tab-content">
      <h2>Booking Source Mapping</h2>
      <div className="uk-card hms-left-tabs-content-card uk-padding-remove">
        <table className="uk-table uk-table-hover uk-table-divider hms-table">
          <thead>
            <tr>
              <th>SOURCE</th>
              <th>MAPPED SOURCE</th>
              <th>BOOKING COUNT</th>
            </tr>
          </thead>
          <tbody>
            {paginated?.length ? (
              paginated.map((item, idx) => (
                <tr key={item.source || idx}>
                  <td>{item.source || "-"}</td>
                  <td>{item.formatted_source || "Source Not Mapped"}</td>
                  <td>{Number(item.booking_count).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="no-results">
                  No booking sources found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Flex alignment="between top" className="guest-form-top-filters">
        <Pagination
          count={total}
          index={page}
          onIndexChanged={handlePageChange}
        />
        {total > 0 && <RecordsPerPage />}
      </Flex>
    </li>
  );
};

export default BookingSourceMapping;